export default "__VITE_ASSET__53e16dfa__"